function isNetworkDisconnect({ status, message } = {}) {
  return status === 0 || !window.navigator.onLine || message === 'Network Error'
}

export default isNetworkDisconnect
